import type { ComponentType } from 'react';

import { withFlags, type WithFlagsProps } from '@confluence/flags/entry-points/withFlags.ts';

import { useConnectionsFeedbackFlag } from './useConnectionsFeedbackFlag.tsx';

type ConnectionsFeedbackFlagProps = {
	contentId: string;
	isMenuReady: boolean;
	onShareFeedback?: () => void;
};

const ConnectionsFeedbackFlagInner = (
	props: ConnectionsFeedbackFlagProps & WithFlagsProps,
): null => {
	useConnectionsFeedbackFlag(props);
	return null;
};

export const ConnectionsFeedbackFlag: ComponentType<ConnectionsFeedbackFlagProps> = withFlags(
	ConnectionsFeedbackFlagInner,
);
